export const HUSTRO_CLIENT = 'web';
export const HUSTRO_API_VERSION = '2';

export function getHustroClientHeaders(frontendVersion: string): Record<string, string> {
  return {
    'hustro-client': HUSTRO_CLIENT,
    'hustro-client-version': frontendVersion,
    'hustro-api-version': HUSTRO_API_VERSION,
  };
}
